/* eslint-disable react/jsx-pascal-case */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { WithRouter } from 'decorators/withRouter';
import { GOOGLE_ANALYTICS_ID } from 'settings';

import BasePageContainer from '../Pages/Container';
import Login from 'components/Login';

declare let gtag: (command: string, googleAnalyticsId: string, value: any) => void;

@WithRouter()
class Router extends PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    this.props.history.listen(() => {
      gtag('config', GOOGLE_ANALYTICS_ID, { page_path: document.location.pathname });
    });
  }

  renderRoutes(Component: any, auth: any, baseUrl: any = '') {
    return (
      <Switch>
        <Component.type>
          <Switch>
            {(Component.type.routes || []).map((route: any, index: any) => {
              const path = baseUrl + route.path;
              const component = route.component;

              let SubComponent = React.createElement(component) as any;
              SubComponent =
                SubComponent.type.routes && SubComponent.type.routes.length ? (
                  this.renderRoutes(SubComponent, auth, path)
                ) : (
                  <BasePageContainer blankPage={route?.blankPage}>{SubComponent}</BasePageContainer>
                );

              return (
                <Route
                  key={index}
                  path={path}
                  exact={route.exact}
                  render={(props: any) => {
                    if (this.props.onRender) {
                      this.props.onRender(props);
                    }
                    return this.handleAuthentication(SubComponent, route, auth, props);
                  }}
                />
              );
            })}
          </Switch>
        </Component.type>
      </Switch>
    );
  }

  handleAuthentication(Component: any, route: any, auth: any, props: any) {
    if (auth !== undefined && !route.allowAnonymous) {
      const isAuthenticated = auth === (route.authenticWhen === undefined && true);

      if (isAuthenticated) {
        return Component;
      }
      if (route.redirect) {
        return (
          <Redirect
            from={route.path}
            to={route.redirect instanceof Function ? route.redirect(props) : route.redirect}
          />
        );
      } else {
        return <Login />;
      }
    }

    return Component;
  }

  render() {
    return this.renderRoutes(this.props.children, this.props.authenticated);
  }
}

export default connect((state: any) => ({
  subdomain: state.template.base.subdomain,
}))(Router);
